import { takeEvery, put, call } from "redux-saga/effects";

import {
  showErrorMessage,
  showSuccessMessage
} from "../../../redux-saga/redux/toast";
import FavouriteService from "../../services/favourites";
import {
  addOrRemoveFavouriteStart,
  addOrRemoveFavouriteSuccess,
  addOrRemoveFavouriteFailure
} from "../../redux/favourites";
import { getLiveMatchesStart, getPreMatchesStart } from "../../redux/matches";

function* favouriteWatcher() {
  yield takeEvery(addOrRemoveFavouriteStart.type, favouriteWorker);
}

function* favouriteWorker(action) {
  try {
    const { data, error } = yield call(
      FavouriteService.addOrRemoveFavourites,
      action.payload
    );
    if (data) {
      yield put(addOrRemoveFavouriteSuccess(data));
      if (data?.isFavorite) {
        yield put(
          showSuccessMessage({ tKey: "SB_HOME.MATCH_ADDED_TO_FAVOURITES" })
        );
      } else {
        yield put(
          showErrorMessage({ tKey: "SB_HOME.MATCH_REMOVED_FROM_FAVOURITES" })
        );
      }

      if (action.payload.isFavouritePage) {
        if (action.payload?.isLive) {
          yield put(
            getLiveMatchesStart({
              sportId: action.payload?.sportId,
              isLive: true,
              page: action?.payload?.page,
              limit: 9,
              fromDate: null,
              endDate: null,
              search: "",
              isFavourite: true,
              loadingFalse: true
            })
          );
        } else {
          yield put(
            getPreMatchesStart({
              sportId: action.payload?.sportId,
              isLive: action.payload?.isLive,
              page: action?.payload?.page,
              limit: 9,
              fromDate: null,
              endDate: null,
              search: "",
              isFavourite: true,
              loadingFalse: true
            })
          );
        }
      }
    }
    if (error) {
      yield put(addOrRemoveFavouriteFailure());
      yield put(showErrorMessage({ msg: error }));
    }
  } catch (error) {
    yield put(addOrRemoveFavouriteFailure());
    yield put(showErrorMessage({ msg: error }));
  }
}

export default favouriteWatcher;
